import React from 'react';
import ChartWrapper from 'src/frontend-common/components/Charts/Wrapper';
import { scatterPlotTooltip } from 'src/pages/FeatureAnalysis/utils';
import { ScatterStripCluster } from 'src/pages/FeatureAnalysis/FeatureAnalysisTypes';

interface InsightsScatterChartProps {
  activeTab: number;
  parsedScatterData: Record<string, any> | undefined;
  scatterData: ScatterStripCluster[] | undefined;
  isErrorDataAnalysis: boolean;
  isLoadingDataAnalysis: boolean;
}

const InsightsScatterChart: React.FC<InsightsScatterChartProps> = ({
  activeTab,
  parsedScatterData,
  scatterData,
  isErrorDataAnalysis,
  isLoadingDataAnalysis,
}) => {
  const pushToCustomerPage = (resolution_id: string) => {
    if (resolution_id) window.open(`/customer/${resolution_id}`, '_blank');
  };
  return (
    <ChartWrapper
      components={[
        {
          title: 'Sample distribution across score',
          infoData: scatterPlotTooltip,
          chart: {
            type: 'insightScatterChart',
            data: [
              ...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['poor']) || []),
              ...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['bad']) || []),
              ...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['moderate']) || []),
              ...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['good']) || []),
              ...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['high']) || []),
            ],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'All',
        },
        {
          title: 'Sample distribution across score',
          chart: {
            type: 'insightScatterChart',
            data: [...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['poor']) || [])],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'Poor',
        },
        {
          title: 'Sample distribution across score',
          chart: {
            type: 'insightScatterChart',
            data: [...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['bad']) || [])],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'Bad',
        },
        {
          title: 'Sample distribution across score',
          chart: {
            type: 'insightScatterChart',
            data: [...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['moderate']) || [])],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'Moderate',
        },
        {
          title: 'Sample distribution across score',
          chart: {
            type: 'insightScatterChart',
            data: [...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['good']) || [])],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'Good',
        },
        {
          title: 'Sample distribution across score',
          chart: {
            type: 'insightScatterChart',
            data: [...((parsedScatterData && scatterData && parsedScatterData['scatter_strip']['high']) || [])],
            cluster: activeTab,

            history: pushToCustomerPage,
          },
          tabLabel: 'High',
        },
      ]}
      isLoading={isLoadingDataAnalysis}
      isError={isErrorDataAnalysis}
    />
  );
};

export default InsightsScatterChart;
